import { c as _c } from "react/compiler-runtime";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import omit from "lodash-es/omit";
import Link from "next/link";
import { type MouseEvent } from "react";
import { AccommodationCardLinkProperties } from "./accommodation-card-link.types";
import { sanitizeAccommodationCardHref, sanitizeAccommodationCardQuery } from "./accommodation-card-link.utils";
const MODAL_QUERY_KEYS = ["modal", "selectedHotelId"];
const getAccommodationCardHref = ({
  href,
  pathname,
  query
}: Pick<AccommodationCardLinkProperties, "href" | "pathname" | "query">) => sanitizeAccommodationCardHref(href) || {
  pathname,
  query: sanitizeAccommodationCardQuery(query)
};
const shouldUseBrowserNavigation = (event: MouseEvent<HTMLElement>, target?: string) => target === "_blank" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
export const AccommodationCardLink: React.FC<AccommodationCardLinkProperties> = properties => {
  const $ = _c(31);
  const router = useCompatRouter();
  let t0;
  if ($[0] !== properties || $[1] !== router) {
    t0 = event => {
      properties.onClick?.(event);
      if (event.defaultPrevented || shouldUseBrowserNavigation(event, properties.target)) {
        return;
      }
      event.preventDefault();
      const navigate = router.query.modal || properties.replace ? "replace" : "push";
      if (properties.pathname) {
        if (typeof properties.query === "string") {
          const query = sanitizeAccommodationCardQuery(properties.query);
          return router[navigate](`${properties.pathname}${!query || String(query).startsWith("?") ? "" : "?"}${query}`);
        }
        return router[navigate](properties.pathname, sanitizeAccommodationCardQuery(properties.query ? omit(properties.query, MODAL_QUERY_KEYS) : {}));
      }
      if (properties.href) {
        return router[navigate](sanitizeAccommodationCardHref(properties.href));
      }
    };
    $[0] = properties;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleClick = t0;
  if (properties.shouldRedirectUsingJs) {
    let t1;
    if ($[3] !== properties) {
      t1 = omit(properties, "href", "prefetch", "replace", "role", "target", "title", "noFollow", "id", "onClick");
      $[3] = properties;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    let t2;
    let t3;
    if ($[5] !== properties) {
      t2 = () => properties?.onMouseEnter && properties?.onMouseEnter(properties.id);
      t3 = () => properties?.onMouseLeave && properties?.onMouseLeave(properties.id);
      $[5] = properties;
      $[6] = t2;
      $[7] = t3;
    } else {
      t2 = $[6];
      t3 = $[7];
    }
    let t4;
    if ($[8] !== handleClick || $[9] !== properties.children || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
      t4 = <div {...t1} onClick={handleClick} onMouseEnter={t2} onMouseLeave={t3}>{properties.children}</div>;
      $[8] = handleClick;
      $[9] = properties.children;
      $[10] = t1;
      $[11] = t2;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  const t1 = properties.className;
  let t2;
  if ($[14] !== properties) {
    t2 = getAccommodationCardHref(properties);
    $[14] = properties;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  const t3 = properties.prefetch ?? true;
  const t4 = properties?.replace;
  const t5 = properties.noFollow ? "nofollow" : undefined;
  const t6 = properties?.target;
  const t7 = properties?.title;
  let t8;
  let t9;
  if ($[16] !== properties) {
    t8 = () => properties?.onMouseEnter && properties?.onMouseEnter(properties.id);
    t9 = () => properties?.onMouseLeave && properties?.onMouseLeave(properties.id);
    $[16] = properties;
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  let t10;
  if ($[19] !== handleClick || $[20] !== properties.children || $[21] !== properties.className || $[22] !== t2 || $[23] !== t3 || $[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t10 = <Link className={t1} href={t2} prefetch={t3} replace={t4} rel={t5} role="link" target={t6} title={t7} onClick={handleClick} onMouseEnter={t8} onMouseLeave={t9}>{properties.children}</Link>;
    $[19] = handleClick;
    $[20] = properties.children;
    $[21] = properties.className;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};